//form fields
ui.formFieldSelect = function(){
	var scope = ".js-form-field-select";

	ui.ready(
		scope,
		function($field){
		    var $select = $field.find(scope+"__select");
            $field.data(
                "funcGetVal",
                function(){
                    return $select.val();
                }
            );

            $field.data(
                "funcSetVal",
                function(val){
                    $select.find("[value='"+val+"']").prop("selected",true);
                    $field.trigger("formField:changeVal");
                }
            );

            $select.change(
                function(){
                    $field.trigger("formField:changeVal");
                }
            );

            if($select.attr("readonly")){
                $select.css("pointer-events","none");
            }
		}
	);
}();